/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Fisify API
 * OpenAPI spec version: 1.0.0
 */

export type SessionTarget = typeof SessionTarget[keyof typeof SessionTarget];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SessionTarget = {
  an_usual_day: 'an_usual_day',
  sports_players: 'sports_players',
  exercise_in_office: 'exercise_in_office',
  work_without_pain: 'work_without_pain',
  holidays: 'holidays',
  muscle_relajation: 'muscle_relajation',
  top_exercises: 'top_exercises',
  mobility_programs: 'mobility_programs',
  experimental: 'experimental',
  fisifyoffice: 'fisifyoffice',
  fisifydrivers: 'fisifydrivers',
  office2: 'office2',
  office2complementary: 'office2complementary',
  work: 'work',
  workcomplementary: 'workcomplementary',
  office: 'office',
  fabric: 'fabric',
  driver: 'driver',
  stand: 'stand',
  health: 'health',
  running: 'running',
  cycling: 'cycling',
  football: 'football',
  basket: 'basket',
  padel: 'padel',
  swimming: 'swimming',
  trailrunning: 'trailrunning',
  gym: 'gym',
  lazy: 'lazy',
  mobility: 'mobility',
  spine_health: 'spine_health',
  fitness: 'fitness',
  antistress: 'antistress',
  health_professionals: 'health_professionals',
} as const;
